<template>
<div>
    <amenity-form
        :is-amenity-form-sidebar-active.sync="isAmenityFormSidebarActive"
        :amenity-data="amenityData"
        @refetch-data="refetchAmenityData" 
    />
    <b-card no-body>
        <div class="m-2">
            <b-row>
                <b-col
                    cols="12"
                    md="6"
                    class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
                >
                </b-col>
                <b-col
                    cols="12"
                    md="6"
                >
                    <div class="d-flex align-items-center justify-content-end">
                        <b-form-input
                            v-model="searchQuery"
                            class="d-inline-block mr-1"
                            placeholder="Search..."
                        />
                        <b-button
                            variant="primary"
                            @click="updateAmenity()"
                        >
                            <span class="text-nowrap">Add Amenity</span>
                        </b-button>
                    </div>
                </b-col>
            </b-row>
        </div>

        <table class="table table-striped">
            <thead>
                <tr>
                <th scope="col" v-for="col in tableColumns" :key="col.key">
                    {{col.label}}
                </th>
                </tr>
            </thead>
            <tr v-for="(item, index) in amenities" :key="index">
                <td class="pl-2">
                    <b-img
                        :src="item.icon?item.icon:require(`@/assets/images/no-image.png`)"
                        height="75"
                        width="75"
                        class="rounded m-0"
                    />
                </td>
                <td class="pl-2">
                    <span v-html="item.title[currentLocale]"></span>
                </td>
                <td class="pl-2">
                    <span v-html="item.slug[currentLocale]"></span>
                </td>
                <td class="pl-2">
                    <b-badge
                        pill
                        :variant="`light-${resolveAmenityStatusVariant(item.is_active)}`"
                        class="text-capitalize"
                    >
                        {{ resolveAmenityStatusnameVariant(item.is_active) }} 
                    </b-badge>
                </td>
                <td class="pl-2">
                    <b-button  v-ripple.400="'rgba(113, 102, 240, 0.15)'"  @click="updateAmenity(item)" variant="outline-success">Edit</b-button>
                    <b-button  v-ripple.400="'rgba(113, 102, 240, 0.15)'" class="ml-1" @click="deleteconfirm(item.id)" variant="outline-danger">Delete</b-button>
                </td>
            </tr>
        </table>

        <div class="mx-2 mb-2">
            <b-row>
                <b-col
                    cols="12"
                    sm="6"
                    class="d-flex align-items-center justify-content-center justify-content-sm-start"
                >
                    <span class="text-muted">Showing {{ dataMeta.from }} to {{ dataMeta.to }} of {{ dataMeta.of }} entries</span>
                </b-col>
                <b-col
                    cols="12"
                    sm="6"
                    class="d-flex align-items-center justify-content-center justify-content-sm-end"
                >
                    <b-pagination
                        v-model="currentPage"
                        :total-rows="totalAmenities"
                        :per-page="perPage"
                        first-number
                        last-number
                        class="mb-0 mt-1 mt-sm-0"
                        prev-class="prev-item"
                        next-class="next-item"
                    >
                        <template #prev-text>
                            <feather-icon
                                icon="ChevronLeftIcon"
                                size="18"
                            />
                            </template>
                            <template #next-text>
                            <feather-icon
                                icon="ChevronRightIcon"
                                size="18"
                            />
                        </template>
                    </b-pagination>
                </b-col>
            </b-row>
        </div>
    </b-card>
</div>
</template>

<script>
import {
    BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink,
    BBadge, BDropdown, BDropdownItem, BPagination, BTooltip, VBModal, BFormGroup,
    BFormCheckbox, BImg,
} from 'bootstrap-vue';
import draggable from 'vuedraggable'
import { ref,onUnmounted } from '@vue/composition-api'
import store from '@/store'
import Ripple from 'vue-ripple-directive';
import AmenityForm from './AmenityForm.vue';
import roomStoreModule from '../roomStoreModule';
import useAmenityList from './useAmenityList'
import { MenuIcon } from 'vue-feather-icons'

export default {
    components: {
        BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink,
        BBadge, BDropdown, BDropdownItem, BPagination, BTooltip, VBModal, BFormGroup, BFormCheckbox,
        AmenityForm, draggable, MenuIcon, BImg,
    },
    directives: {
        'b-modal': VBModal,
        Ripple
    },
    computed: {
        currentLocale() {
            return  this.$i18n.locale;
        },
    },
    setup() {
        const CAT_STORE_MODULE_NAME = 'app-room';
        if (!store.hasModule(CAT_STORE_MODULE_NAME)) store.registerModule(CAT_STORE_MODULE_NAME, roomStoreModule)
        onUnmounted(() => {
            if (store.hasModule(CAT_STORE_MODULE_NAME)) store.unregisterModule(CAT_STORE_MODULE_NAME)
        });

        const {
            isAmenityFormSidebarActive,
            amenityData,
            refetchAmenityData,
            fetchAmenityData,
            updateAmenity,
            searchQuery,
            refAmenityListTable,
            amenities,
            tableColumns,
            sortBy,
            isSortDirDesc,
            resolveAmenityStatusVariant,
            resolveAmenityStatusnameVariant,
            dataMeta,
            totalAmenities,
            perPage,
            currentPage,
            deleteData,
        } = useAmenityList()

        fetchAmenityData()

        return {
            isAmenityFormSidebarActive,
            amenityData,
            refetchAmenityData,
            fetchAmenityData,
            updateAmenity,
            searchQuery,
            refAmenityListTable,
            amenities,
            tableColumns,
            sortBy,
            isSortDirDesc,
            resolveAmenityStatusVariant,
            resolveAmenityStatusnameVariant,
            dataMeta,
            totalAmenities,
            currentPage,
            deleteData,
            perPage
        }
    },
    methods:{
        deleteconfirm(id){
            this.$bvModal
                .msgBoxConfirm(`Please confirm that you want to delete Amenity ID = ${id}`, {
                    title: 'Please Confirm',
                    size: 'sm',
                    okVariant: 'danger',
                    okTitle: 'Yes',
                    cancelTitle: 'No',
                    cancelVariant: 'outline-secondary',
                    hideHeaderClose: false,
                    centered: true,
                })
                .then(value => {
                    if(value === true){
                    this.deleteData(id)
                }
            })
        },
    }
}
</script>